module.exports = __webpack_public_path__ + "static/img/senceIcon1.0e0437d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/senceIcon1.png
// module id = bxHA
// module chunks = 1